"use client";

import CtaLink from "@/shared/components/common/CtaLink";

export default function LandingSupportCTA() {
  return (
    <section className="py-16 sm:py-20 bg-[#2d2d2d]">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <h2 className="text-[1.75rem] sm:text-[2.25rem] font-bold text-white font-winky leading-tight mb-3">
          Ready to rethink your wardrobe?
        </h2>
        <p className="text-white/75 text-[14px] sm:text-[16px] font-patrick mb-8 max-w-lg mx-auto">
          Join thousands of users who get dressed smarter every morning.
          42 free coins on signup.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <CtaLink
            ctaName="get_started"
            ctaLocation="closing_cta"
            href="/login?action=signup"
            className="inline-flex items-center gap-2 rounded-full bg-[#ffd372] border border-[#ffd372] px-8 py-3.5 font-winky text-[14px] sm:text-[15px] font-bold text-[#2d2d2d] transition-all duration-200 hover:scale-105 active:scale-95 shadow-lg"
          >
            Get Started Free &rarr;
          </CtaLink>
          <CtaLink
            ctaName="contact_support"
            ctaLocation="closing_cta"
            href="/support"
            className="inline-flex items-center gap-2 rounded-full border border-white/30 px-6 py-3.5 font-winky text-[14px] font-bold text-white transition-all duration-200 hover:bg-white/10"
          >
            Contact Support
          </CtaLink>
        </div>
      </div>
    </section>
  );
}
